module.exports = __webpack_public_path__ + "img/sharp-example3.79bc3b59.jpg";